export const gift = {
    gift_title: 'Tu evolución',
    gift_points_1 : 'Tienes',
    gift_points_2 : 'puntos',
    gift_find_gift: 'Encuentra mi regalo',
}
